module.exports = __webpack_public_path__ + "static/media/Nathan_Logo.d9cfccde.png";